export default "__VITE_ASSET__Cw85bNvo__"